module.exports = __webpack_public_path__ + "static/media/PESEMP_MENU-normal.6225a523.png";